import $ from 'jquery';
import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';
import ScrollToPlugin from '../lib/ScrollToPlugin.min';
import SplitText from '../lib/SplitText.min';
import DrawSVGPlugin from '../lib/DrawSVGPlugin.min';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, SplitText, DrawSVGPlugin);

import Swiper from '../lib/swiper-bundle.min';

export function main() {

'use strict';

var winW = $(window).width();
var winH = $(window).height();
var body = $('body');

const winsize = () => {
	winW = $(window).width();
	winH = $(window).height();
	const vw = winW;
	document.documentElement.style.setProperty('--vw', vw+'px');
	const vh = winH;
	document.documentElement.style.setProperty('--vh', vh+'px');
}


let EL_scrollTrigger;
const elFunc = (EL) => {
	gsap.utils.toArray(EL).forEach(target => {
		if(window.matchMedia('(max-width:599px)').matches){
			if(target.classList.contains('nosp')){
				return;
			}
		}
		if(!target.classList.contains('nomove')){
			target.style.opacity = 0;
		}
		EL_scrollTrigger = ScrollTrigger.create({
			trigger: target,
			start: "top bottom",
			once: true,
			onEnter: self => {
				elAnime(target);
			},
		});

		const navh = document.getElementById('nav').clientHeight;
		const up_scrollTrigger = ScrollTrigger.create({
			trigger: 'body',
			start: "top top",
			onUpdate: self => {
				const _slfscrl = self.scroll();
				if(self.direction == -1){
					document.body.classList.remove('scrldown');
				}else{
					if(_slfscrl > navh){
						if(self.prevSclrl < _slfscrl-1){
							document.body.classList.add('scrldown');
						}
						self.prevSclrl = _slfscrl;
					}
				}
			},
		});		
	});
}

const elAnime = (target) => {
	target.style.opacity = 1;
	if(target.classList.contains('elp')){
		var elc = target.querySelectorAll('.elc');
	}else{
		var elc = [target];
	}
	elc.forEach((elc, i) => {
		let _y = 120;
		let _opa = 0;
		gsap.fromTo(elc,{y:_y,opacity:_opa},{
			y: 0,
			opacity:1,
			duration: 0.8,
			delay: i * 0.2,
			ease:'power1',
			onComplete: function(){
				elc.classList.add('elon');
			}
		});
	});
}


function pageScroll(){
	$('a.anchor').on('click', function(){
		let href = this.hash;
		let offset = 0;
		if(this.dataset.offset != undefined) {
			offset = this.dataset.offset * winH * -1;
		}
		gsap.to(window, {scrollTo:{y:href, offsetY:offset}});
		nav_hide();
		return false;
	});
}


function nav_show(){
	body.addClass('navopen');
}
function nav_hide(){
	body.removeClass('navopen');
}
function navInit(){
	$('#navbtn').on('click', function(){
		if( body.hasClass('navopen') ){
			nav_hide();
		}else{
			nav_show();
		}
	});
}


function ytLoadFunc() {
	if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);		
	}
	window.onYouTubePlayerAPIReady = function() {
		ytPlayerFunc();
	};
}
var player;
var _videoid = document.getElementById('ytplayer').dataset.videoid;
var ytpVars = {
	'controls': false,
	'disablekb': 1,
	'loop': 1,
	'playlist': _videoid,
	'modestbranding': 1,
	'rel': 0,
	'playsinline': 1,
};
function ytPlayerFunc() {
	player = new YT.Player('ytplayer', {
		videoId: _videoid,
		playerVars: ytpVars,
		events: {
			'onReady': onPlayerReady,
		},
	});
	ytModalPlayerFunc();
}
function onPlayerReady(event) {
	event.target.mute();
	event.target.playVideo();
}

var modalplayer;
function ytModalPlayerFunc() {
	modalplayer = new YT.Player('mplayer', {
		videoId: _videoid,
		playerVars: ytpVars,
	});
	$('#ytp_wrap').on('click', function(){
		body.addClass('modalopen');
		modalplayer.seekTo(0);
		modalplayer.playVideo();
	});
	$('#mclose').on('click', function(){
		body.removeClass('modalopen');
		modalplayer.pauseVideo();
	});
}


function emblemFunc() {
	const newemblem = document.getElementById('newemblem');
	const embwrap_bg = document.getElementById('embwrap_bg');
	const emb = document.getElementById('emblem');
	const bg = document.getElementById('emb_bg');
	const l1 = document.getElementById('emb_line1');
	const l2 = document.getElementById('emb_line2');
	const l3 = document.getElementById('emb_line3');
	const ls = document.getElementById('emb_lines');
	const ls2 = document.getElementById('emb_lines2');
	const t_new = document.getElementById('t_new');
	const t_con = document.getElementById('t_con');
	const t_des = document.getElementById('t_des');

	const em0 = '#em0 .te';
	const em1 = '#em1 .te';
	const em2 = '#em2 .te';
	const em3 = '#em3 .te';
	const em4 = '#em4 .te';
	const ti1 = '#ti1';
	const ti2 = '#ti2';
	const ti3 = '#ti3';
	const ti4 = '#ti4';
	const ti5 = '#ti5';
	const c1 = '#000A6E';
	const c2 = '#FF0000';
	const c3 = '#BE9664';
	const c4 = '#EFEFFF';
	const c5 = '#F2DAEF';

	let _w00,_w0,_w1,_w2,_w3,_w4,
			_x00,_x0,_x1,_x2,_x3,_x4,
			_y00,_y0,_y1,_y2,_y3,_y4,
			_embbd_w;

	const _txtstart1 = {opacity:0, x:'25vw'};
	const _txtstart2 = {opacity:0, x:'-25vw'};
	const _txtend = {opacity:1, x:0, stagger: {each:.2}};

	const _tis1 = {width:'100vw', xPercent:'200%'};
	const _tis2 = {width:'100vw', xPercent:'-200%'};
	const _tie = {width:'100%', xPercent:0, duration:1.5};

	const emb_tl = () => {
		gsap.set(emb, {width:_w00,x:_x00,y:_y00});
		gsap.set(embwrap_bg, {background:'linear-gradient(#0F1837, #0F1837)'});

		var tl = gsap.timeline({
			defaults: {
				duration: 0.8,
				ease: 'power4.out',
			},
			scrollTrigger: {
				trigger: newemblem,
				start: "top top",
				end: "bottom bottom",
				scrub: 1,
			}
		})


		//Change color
		.set('.emtxt i', {width:'300%'})
		.set(ls2, {opacity:0}, '<')
		
		.to(emb, {width:_w0,x:_x0,y:_y0}, '+=3.0')
		.fromTo(em0, _txtstart1, _txtend, '<')
		.fromTo(t_new, {opacity:1}, {opacity:0}, '<')
		.fromTo(t_con, {opacity:0}, {opacity:1}, '<')
		.to(embwrap_bg, {background:'linear-gradient(#0F1837, #000A6E)'}, '<')

		.to(em0, _txtstart1, '+=3.0')
		.to(t_con, {opacity:0}, '<')
		.fromTo(t_des, {opacity:0}, {opacity:1}, '<')
		.to(embwrap_bg, {background:'linear-gradient(#000A6E, #000A6E)'}, '<')
		.to(newemblem, { background:c1 }, '<')
		.fromTo(bg, {fill:c1}, {fill:c4}, '<')
		.to(ls, {opacity:0}, '<')
		.fromTo(l1, {fill:c2}, {fill:c5}, '<')
		.fromTo(l2, {fill:c2}, {fill:c5}, '<')
		.fromTo(l3, {fill:c2}, {fill:c5}, '<')
		.to(emb, {width:_w1, x:_x1, y:_y1}, '<')

		//Set 1st
		.to(l1, { fill:c2 })
		.fromTo(em1, _txtstart1, _txtend, '<')
		.to(ti1, _tie, '<')

		//Set 2st
		.to(l1, { fill:c5 }, '+=3.0')
		.to(em1, _txtstart1, '<')
		.to(ti1, _tis1, '<')
		.to(emb, {width:_w2, x:_x2, y:_y2}, '<')
		.to(l2, { fill:c2 })
		.fromTo(em2, _txtstart1, _txtend, '<')
		.to(ti2, _tie, '<')

		//Set 3st
		.to(l2, { fill:c5 }, '+=3.0')
		.to(em2, _txtstart1, '<')
		.to(ti2, _tis1, '<')
		.to(emb, {width:_w3, x:_x3, y:_y3}, '<')
		.to(l3, { fill:c2 })
		.fromTo(em3, _txtstart2, _txtend, '<')
		.to(ti3, _tie, '<')

		//Set 4st
		.to(l3, { fill:c5 }, '+=3.0')
		.to(em3, _txtstart2, '<')
		.to(ti3, _tis2, '<')
		.to(emb, {width:_w4, x:_x4, y:_y4}, '<')
		.to(ls, {opacity:1})
		.fromTo(em4, _txtstart2, _txtend, '<')
		.to(ti4, _tie, '<')

		.to(ls, {opacity:1}, '+=1.0');
	}

	let mm = gsap.matchMedia();
	mm.add("(min-width: 0px) and (max-width: 599px)", () => {
		_embbd_w = 25;
		_w00 = '65%';
		_w0 = '45%';
		_w1 = '75%';
		_w2 = '75%';
		_w3 = '75%';
		_w4 = '60%';
		_x00 = 0;
		_x0 = 0;
		_x1 = -window.innerWidth*0.15;
		_x2 = window.innerWidth*0.15;
		_x3 = -window.innerWidth*0.15;
		_x4 = 0;
		_y00 = 0;
		_y0 = -window.innerHeight*0.18;
		_y1 = -window.innerHeight*0.2;
		_y2 = window.innerHeight*0.23;
		_y3 = window.innerHeight*0.23;
		_y4 = window.innerHeight*0.15;
		emb_tl();
	});
	mm.add("(min-width: 600px)", () => {
		_embbd_w = 70;
		_w00 = '30%';
		_w0 = '25%';
		_w1 = '50%';
		_w2 = '45%';
		_w3 = '45%';
		_w4 = '25%';
		_x00 = 0;
		_x0 = -window.innerWidth*0.25;
		_x1 = -window.innerWidth*0.25;
		_x2 = -window.innerWidth*0.25;
		_x3 = window.innerWidth*0.25;
		_x4 = window.innerWidth*0.25;
		_y00 = window.innerHeight*0.05;
		_y0 = 0;
		_y1 = -window.innerHeight*0.2;
		_y2 = window.innerHeight*0.2;
		_y3 = window.innerHeight*0.2;
		_y4 = 0;
		emb_tl();
	});

}


function txtEffectInit (target){
	gsap.utils.toArray(target).forEach((el,i) => {
		let mySplitText = new SplitText(el, { type: "chars" });
		let chars = mySplitText.chars;
		chars.forEach((char, i) => {
			gsap.set(char, {opacity:0});
		});
	});
}


function kvEffect (){
	txtEffectInit('.txef');
	gsap.set('#kvtxtjp_p', {opacity:0});
	let _y;
	if(window.matchMedia('(max-width:599px)').matches){
		_y = 60;
	}else{
		_y = 100;
	}
	const scrollTrigger = ScrollTrigger.create({
		trigger: '#kv',
		start: "top bottom",
		// once: true,
		onEnter: self => {
			const tar = document.querySelector('.kvtxt');
			gsap.utils.toArray('.kvtxt').forEach((tar,k) => {
				let chars = tar.querySelectorAll('div');
				const _from = () => {
					return {
						opacity:0,
						x:0,
						y:_y,
						transformOrigin: "left",
					};
				}
				const _to = (i) => {
					return {
						opacity:1,
						x:0,
						y:0,
						transformOrigin: "left",
						duration: 2.4,
						delay: k * 0.05,
						ease:'power4.inOut',
					};
				}
				chars.forEach((char, i) => {
					gsap.timeline()
					.fromTo(char, _from(), _to(i))
					.fromTo('#kvtxtjp_p', _from(), _to(0), '<')
				});
			});
		},
	});
}


function structureFunc (){
	const _from = {drawSVG:'0%'};
	const _to = {drawSVG:'100%', stagger: 0.2};

	gsap.timeline({
		defaults: {
			duration: 1,
			ease: 'power1.out',
		},
		scrollTrigger: {
			trigger: '#structure',
			start: "top top+=10%",
			end: "bottom bottom",
			scrub: 1,
		}
	})
	.fromTo('#struc_txt p', {opacity:0, x:-winW*0.25}, {opacity:1, x:0})
	.fromTo('#pentagon .line', _from, _to)
	.fromTo('#pentagon .star', _from, _to)
	.fromTo('#pentagon .curve', _from, _to)
	.fromTo('#pentagon .tx', {opacity:0}, {opacity:1}, '<')
	.fromTo('#pentagon', {opacity:1}, {opacity:0}, '+=3.0')
	.fromTo('#hexagon .line', _from, _to)
	.fromTo('#hexagon .curve', _from, _to)
	.fromTo('#hexagon .tx', {opacity:0}, {opacity:1}, '<')
	.to('#hexagon .tx', {opacity:1}, '+=1.0');
}


function logotypeFunc (){
	const logotype_tl = () => {
		gsap.timeline({
			defaults: {
				duration: 1,
				ease: 'power1.out',
			},
			scrollTrigger: {
				trigger: '#logotype',
				start: "top center",
				end: "top top",
				scrub: 1,
			}
		})
		.fromTo(_el1, {opacity:0, y:120}, {opacity:1, y:0})
		.fromTo(_el2, {opacity:0, y:120}, {opacity:1, y:0}, '-=0.5')
	}

	let mm = gsap.matchMedia();
	let _el1,_el2;
	mm.add("(min-width: 0px) and (max-width: 599px)", () => {
		_el1 = '#logotype_txt p'
		_el2 = '#logotype_logo';
		logotype_tl();
	});
	mm.add("(min-width: 600px)", () => {
		_el1 = '#logotype_logo';
		_el2 = '#logotype_txt p'
		logotype_tl();
	});

}


function intervewFunc(){
	txtEffectInit('.intvtx');		
	gsap.utils.toArray('.intvblc').forEach((target,i) => {
		let showhide = false;
		const _img = target.querySelector('.img img');
		const _titleset = target.querySelector('.titleset');
		const _txt = target.querySelector('.txt');
		const _from = {opacity:0,y:120};
		const _to = {
			opacity:1,
			y:0,
			duration: 1.2,
			ease: 'power4.out'
		};
		gsap.timeline()
		.set(_titleset, _from)
		.set(_txt, _from, '<')
		.set(_img, {opacity:0, y:120, scale:1.4}, '<');

		const intvw_show = () => {
			gsap.timeline()
			.fromTo(_titleset, _from, _to)
			.fromTo(_txt, _from, _to, '<')
			.fromTo(_img, {opacity:0, y:120, scale:1.4}, {opacity:1, y:0, scale:1}, '<');
			const tar = target.querySelectorAll('.intvtx');
			tar.forEach((_tar, i) => {
				let chars = _tar.querySelectorAll('div');
				chars.forEach((char, i) => {
					gsap.fromTo(char, 
						{opacity:0, y:'150%'},
						{
							opacity:1,
							y:0,
							duration: 1.2,
							ease:'power4.inOut',
						}
					);
				});
			});
			showhide = true;
		}
		const intvw_hide = () => {
			gsap.timeline()
			.fromTo(_titleset, _to, _from)
			.fromTo(_txt, _to, _from, '<')
			.fromTo(_img, {opacity:1, y:0, scale:1}, {opacity:0, y:120, scale:1.4}, '<');
			const tar = target.querySelectorAll('.intvtx');
			tar.forEach((_tar, i) => {
				let chars = _tar.querySelectorAll('div');
				chars.forEach((char, i) => {
					gsap.fromTo(char, 
						{opacity:1, y:0},
						{opacity:0,y:'150%'}
					);
				});
			});
			showhide = false;
		}

		gsap.timeline({
			defaults: {
				duration: 1.2,
				ease: 'power4.out',
			},
			scrollTrigger: {
				trigger: target,
				start: "top center",
				end: "bottom bottom",
				scrub: 1,
				onEnter: self => {
					intvw_show();
				},
				onLeaveBack: self => {
					intvw_hide();
				},
				onUpdate: self => {
					if(self.progress >= 1){
						if(showhide == false){
							intvw_show();
						}
					}
				},
			}
		})
	});
	moreFunc();
}

function moreFunc(){
	let _txtH = $('.txtin').height();
	gsap.set('.p2', {height:0, autoAlpha:0});
	$('.more').on('click', function(){
		$(this).parent().addClass('on');
		const _txtin = $(this).parents('.txt').children('.txtin');
		gsap.to(_txtin, {height:'auto', duration:0.2, onComplete: () => { ScrollTrigger.refresh(); }})
	});
	$('.moreclose').on('click', function(){
		$(this).parent().removeClass('on');
		var target = $(this).parents('.intvblc');
		const _txtin = $(this).parents('.txt').children('.txtin');
		gsap.timeline({
			defaults: {
				duration: 0.3,
				ease: 'power1.out',
			},
		})
		.to(_txtin, {height:_txtH})
		.to(window, {scrollTo:{y:target}, onComplete: () => { ScrollTrigger.refresh(); }});
	});
}


function typoEffect (){
	gsap.utils.toArray('.tys').forEach((el,i) => {
		let mySplitText = new SplitText(el, { type: "chars", charsClass:"char" });
		let chars = mySplitText.chars;		
		chars.forEach((char, i) => {
			char.innerHTML = '<div class="ch">'+char.innerHTML+'</div>';
			gsap.set('.tys .ch', {opacity:0});
		});
	});

	gsap.utils.toArray('.typoset').forEach((target,i) => {
		const typo_effect = () => {
			ScrollTrigger.create({
				trigger: _target,
				start: _start,
				// once: true,
				onEnter: self => {
					const tar_ty = target.querySelectorAll('.ty');
					gsap.utils.toArray(tar_ty).forEach((target) => {
						const tar = target.querySelectorAll('.tys');
						gsap.utils.toArray(tar).forEach((target,k) => {
							if(tar != null){
								let chars = target.querySelectorAll('.ch');
								chars.forEach((char, i) => {
									gsap.fromTo(char, 
										{opacity:0, y:'100%'},
										{
											opacity:1,
											y:0,
											duration: _duration,
											delay: k * 0.05,
											ease:'power4.inOut',
										}
									);
								});
							}
						});
					});
				},
				onLeaveBack: self => {
					const tar = target.querySelectorAll('.tys');
					gsap.utils.toArray(tar).forEach((target,k) => {	
						if(tar != null){
							let chars = target.querySelectorAll('.ch');
							chars.forEach((char, i) => {
								gsap.fromTo(char, 
									{opacity:1, y:0},
									{opacity:0,y:'100%'}
								);
							});
						}
					});
				}
			});
		}

		let _target,_start,_duration;
		let mm = gsap.matchMedia();
		mm.add("(min-width: 0px) and (max-width: 599px)", () => {
			_target = '#typography'
			_start = "top center-=10%";
			_duration = 1.0;
			typo_effect();
		});
		mm.add("(min-width: 600px)", () => {
			_target = target;
			_start = "top center+=10%";
			_duration = 1.6;
			typo_effect();
		});
	});
	numbertypoEffect();
}


function numbertypoEffect (){
	gsap.timeline({
		defaults: {
			duration: 1,
			ease: 'power1.out',
		},
		scrollTrigger: {
			trigger: '#number',
			start: "top bottom-=20%",
			end: "bottom center",
			scrub: 1,
		}
	})
	.fromTo('#number_typo_svg', {left:'100%'}, {left:'-50%'})
	.fromTo('#numberbg', {scaleY:0}, {scaleY:1, transformOrigin: "bottom"}, '<')
}


function colourFunc(){
	gsap.utils.toArray('.colour').forEach((target,i) => {
		const _bg = target.querySelector('.bg');
		const _img = target.querySelector('.img');
		const _num = target.querySelector('.num');

		const color_tl = () => {
			gsap.timeline({
				defaults: {
					duration: 1,
					ease: 'power1.out',
				},
				scrollTrigger: {
					trigger: target,
					start: _start,
					end: _end,
					scrub: 1,
				}
			})
			.fromTo(_bg, {scaleX:0}, {
				scaleX:1,
				transformOrigin: "left top",
				duration: 1.2,
				ease:'power4.inOut'})
			.fromTo(_img, {opacity:0, x:-60}, {opacity:1, x:0}, '+=0.6')
			.fromTo(_num, {opacity:0, x:-60}, {opacity:1, x:0}, '-=0.6')
		}

		let _start,_end;
		let mm = gsap.matchMedia();
		mm.add("(min-width: 0px) and (max-width: 599px)", () => {
			_start = "bottom bottom+="+window.innerHeight/2;
			_end = "bottom bottom-=25%";
			color_tl();
		});
		mm.add("(min-width: 600px)", () => {
			_start = "top bottom-=10%";
			_end = "bottom bottom-=15%";
			color_tl();
		});
	});	
}


function appEffect (){
	const _from = {opacity:0, y:'60px'};
	const _to = {opacity:1, y:0};
	const _fimg = {scale:1.4};
	const _timg = {scale:1};

	gsap.utils.toArray('.appimg').forEach((target,i) => {
		const _img = target.querySelector('img');
		const app_tl = () => {
			gsap.timeline({
				defaults: {
					duration: 1,
					ease: 'power1.out',
				},
				scrollTrigger: {
					trigger: target,
					start: "top bottom-=20%",
					end: "bottom bottom-=10%",
					scrub: 1,
				}
			})
			.fromTo(target, _from, _to)
			.fromTo(_img, _fimg, _timg, '<')	
		}

		let _start,_end;
		if(i == 0){
			_start = 'top bottom';
			_end = 'bottom bottom+=10%';
		}
		if(i == 1){
			_start = 'top bottom-=40%';
			_end = 'bottom bottom-=20%';
		}
		if(i == 2){
			_start = 'top bottom-=20%';
			_end = 'bottom bottom-=20%';
		}
		if(i == 3){
			_start = 'top bottom-=60%';
			_end = 'bottom bottom';
		}
		const app_tl_pc = () => {
			gsap.timeline({
				defaults: {
					duration: 1,
					ease: 'power1.out',
				},
				scrollTrigger: {
					trigger: target,
					start: _start,
					end: _end,
					scrub: 1,
				}
			})
			.fromTo(target, _from, _to)
			.fromTo(_img, _fimg, _timg, '<')	
		}

		let mm = gsap.matchMedia();
		mm.add("(min-width: 0px) and (max-width: 599px)", () => {
			app_tl();
		});
		mm.add("(min-width: 600px)", () => {
			app_tl_pc();
		});
	});
}


function lsEffect (){
	let _delay,img_a,img_b;
	const _from = {opacity:0, scale:1.4};
	const _to = {opacity:1, scale:1};

	gsap.utils.toArray('.ls').forEach((target,i) => {
		const ls_tl = () => {
			gsap.timeline({
				defaults: {
					duration: 1,
					ease: 'power1.out',
				},
				scrollTrigger: {
					trigger: target,
					start: "top bottom",
					end: "bottom bottom",
					scrub: 1,
				}
			})
			.fromTo(img_a, _from, _to)
			.fromTo(img_b, _from, _to, _delay);
		}

		let mm = gsap.matchMedia();
		mm.add("(min-width: 0px) and (max-width: 599px)", () => {
			_delay = '>';
			img_a = target.querySelector('.ls_as img');
			img_b = target.querySelector('.ls_bs img');
			ls_tl();
		});
		mm.add("(min-width: 600px)", () => {
			_delay = '-=0.6';
			img_a = target.querySelector('.ls_a img');
			img_b = target.querySelector('.ls_b img');
			ls_tl();
		});

	});
}


async function ScrollSmootherKill() {
	await new Promise((resolve, reject) => {
		ScrollTrigger.killAll();
		resolve();
	})
}


function initialize(){
	window.addEventListener('DOMContentLoaded', function(){
		elFunc('.el');
		winsize();
		pageScroll();
		navInit();
		ytLoadFunc();
		emblemFunc();
		kvEffect();
		typoEffect();
		structureFunc();
		logotypeFunc();
		intervewFunc();
		colourFunc();
		appEffect();
		lsEffect();
		body.addClass('ready');
		window.addEventListener('resize', function () {
			winsize();
		});
		window.addEventListener('scroll', function () {
			nav_hide();
		});
	});
}

initialize();


}